module.exports = __webpack_public_path__ + "static/img/activity2.8603e5f0.png";